/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusIcon24Solid = forwardRef('MinusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1 12.5A1.5 1.5 0 0 1 2.5 11h18a1.5 1.5 0 0 1 0 3h-18A1.5 1.5 0 0 1 1 12.5Z" })));
});
